"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const cloudProviderFromNodeTypes_1 = __importDefault(
  require("./cloudProviderFromNodeTypes")
);
exports.groupNodesByCloudProvider = nodes => {
  const groups = {};
  nodes.forEach(node => {
    const group = cloudProviderFromNodeTypes_1.default[node.nodeType];
    groups[group] = [...(groups[group] || []), node];
  });
  return groups;
};
//# sourceMappingURL=groupNodesByCloudProvider.js.map
